import { token } from '@atlaskit/tokens';

import {
	WCL_GRID_MAX_WIDTH,
	WCL_GRID_MAX_WIDTH_XL,
	WCL_GRID_PADDING_LG,
	WCL_GRID_PADDING_XL,
} from '@/libraries/design/foundations/grid/src/base';

// Shared geometry; nav-specific breakpoint rules remain in each component.
// Explicit token fallbacks are required when Compiled resolves these imported values.
export const navLayout = {
	height: '68px',
	atlassianLogoWidth: '148px',
	logoHeight: '24px',
	atlassianSquareSize: '68px',
	outerInset: token('space.400', '32px'),
	logoMenuGap: token('space.300', '24px'),
	menuItemPadding: token('space.200', '16px'),
} as const;

// Global columns use the shell's content width (after its outer insets).
// Product columns and compound insets use the full viewport width.
export const navGrid = {
	globalColumnsDesktop: `max(calc(${navLayout.atlassianLogoWidth} + ${navLayout.logoMenuGap}), calc(${WCL_GRID_PADDING_LG}px - ${navLayout.outerInset} - ${navLayout.menuItemPadding}), calc((100% - ${WCL_GRID_MAX_WIDTH}px) / 2 - ${navLayout.menuItemPadding})) minmax(0, 1fr) auto`,
	globalColumnsWide: `max(calc(${navLayout.atlassianLogoWidth} + ${navLayout.logoMenuGap}), calc(${WCL_GRID_PADDING_XL}px - ${navLayout.outerInset} - ${navLayout.menuItemPadding}), calc((100% - ${WCL_GRID_MAX_WIDTH_XL}px) / 2 - ${navLayout.menuItemPadding})) minmax(0, 1fr) auto`,
	productColumnsDesktop: `${navLayout.atlassianSquareSize} max(${navLayout.logoMenuGap}, calc(${WCL_GRID_PADDING_LG}px - ${navLayout.atlassianSquareSize}), calc((100% - ${WCL_GRID_MAX_WIDTH}px) / 2 - ${navLayout.atlassianSquareSize})) minmax(0, 1fr)`,
	productColumnsWide: `${navLayout.atlassianSquareSize} max(${navLayout.logoMenuGap}, calc(${WCL_GRID_PADDING_XL}px - ${navLayout.atlassianSquareSize}), calc((100% - ${WCL_GRID_MAX_WIDTH_XL}px) / 2 - ${navLayout.atlassianSquareSize})) minmax(0, 1fr)`,
	compoundEndInset: `max(${WCL_GRID_PADDING_LG}px, calc((100% - ${WCL_GRID_MAX_WIDTH}px) / 2))`,
	compoundStartInsetWide: `max(calc(${navLayout.outerInset} + ${navLayout.atlassianLogoWidth} + ${navLayout.logoMenuGap} + ${navLayout.menuItemPadding}), ${WCL_GRID_PADDING_XL}px, calc((100% - ${WCL_GRID_MAX_WIDTH_XL}px) / 2))`,
} as const;
